import { useQuery } from "@tanstack/react-query";
import { useAccountStore, useRevenueOverall } from "../../store";
import { getTotalErrorTransactionApi } from "../../services/record-transaction/get.total.error.transaction.api";
import { getDetailErrorTransactionApi } from "../../services/record-transaction/get.detail.error.transaction.api";

export const useGetDetailErrorTransactionApi = ({ page }: { page?: any }) => {
  const { info } = useAccountStore();
  const { startDate, endDate, storeCode, resultId } = useRevenueOverall();
  const { data, isLoading } = useQuery({
    queryKey: [
      "total-error-transaction",
      info?.id,
      endDate,
      startDate,
      storeCode,
      page,
      resultId,
    ],
    queryFn: () =>
      getDetailErrorTransactionApi(
        info?.role !== "ROLE_ADMIN" ? info?.id : undefined,
        startDate,
        endDate,
        storeCode,
        page,
        resultId
      ),
    enabled: !!info?.role && !!startDate && !!endDate,
  });
  return {
    totalDetailError: data,
    isLoading,
  };
};
